import Vue from "vue"
import VueI18n from "vue-i18n"
import router from "@/config/router"

Vue.use(VueI18n)

/* EN - ENGLISH */
import en_global from "../languages/en"
import en_dashboard from "../modules/dashboard/language/en"
import en_settings from "../modules/settings/language/en"
import en_auth from "../modules/auth/language/en"
import en_users from "../modules/users/language/en"
import en_persons from "../modules/persons/language/en"
import en_roles from "../modules/roles/language/en"
import en_permissions from "../modules/permissions/language/en"
import en_organisations from "../modules/organisations/language/en"
import en_coursetemplates from "../modules/coursetemplates/language/en"
import en_tennants from "../modules/tennants/language/en"
import en_logs from "../modules/logs/language/en"
import en_queues from "../modules/queues/language/en"
import en_classes from "../modules/classes/language/en"
import en_coursetypegroups from "../modules/coursetypegroups/language/en"
import en_coursetypes from "../modules/coursetypes/language/en"
import en_moduletemplates from "../modules/moduletemplates/language/en"
import en_moduleoptions from "../modules/moduleoptions/language/en"
import en_moduleoptioncoursetypes from "../modules/moduleoptioncoursetypes/language/en"
import en_customergroups from "../modules/customergroups/language/en"
import en_reports from "../modules/reports/language/en"
import en_educationprograms from "../modules/educationprograms/language/en"
import en_tenantroles from "../modules/tenantroles/language/en"
import en_checklist from "../modules/checklist/language/en"
import en_checklistapi from "../mixins/components/checklist/languages/en"
import en_checklisttemplate from "../modules/checklisttemplate/language/en"
import en_checklisttemplatecategory from "../modules/checklisttemplatecategory/language/en"
import en_integration from "../modules/integrations/language/en"
import en_frontend from "../modules/frontend/language/en"
import en_notificationtemplate from "../modules/notificationtemplates/language/en"
import en_notification from "../modules/notifications/language/en"
import en_changelog from "../modules/changelog/language/en"
import en_modules from "../modules/modules/language/en"

/* NO - NORWEGIAN */
import no_global from "../languages/no"
import no_dashboard from "../modules/dashboard/language/no"
import no_settings from "../modules/settings/language/no"
import no_auth from "../modules/auth/language/no"
import no_users from "../modules/users/language/no"
import no_persons from "../modules/persons/language/no"
import no_roles from "../modules/roles/language/no"
import no_permissions from "../modules/permissions/language/no"
import no_organisations from "../modules/organisations/language/no"
import no_coursetemplates from "../modules/coursetemplates/language/no"
import no_tennants from "../modules/tennants/language/no"
import no_logs from "../modules/logs/language/no"
import no_queues from "../modules/queues/language/no"
import no_classes from "../modules/classes/language/no"
import no_coursetypegroups from "../modules/coursetypegroups/language/no"
import no_coursetypes from "../modules/coursetypes/language/no"
import no_moduletemplates from "../modules/moduletemplates/language/no"
import no_moduleoptions from "../modules/moduleoptions/language/no"
import no_moduleoptioncoursetypes from "../modules/moduleoptioncoursetypes/language/no"
import no_customergroups from "../modules/customergroups/language/no"
import no_reports from "../modules/reports/language/no"
import no_educationprograms from "../modules/educationprograms/language/no"
import no_tenantroles from "../modules/tenantroles/language/no"
import no_checklist from "../modules/checklist/language/no"
import no_checklistapi from "../mixins/components/checklist/languages/no"
import no_checklisttemplate from "../modules/checklisttemplate/language/no"
import no_checklisttemplatecategory from "../modules/checklisttemplatecategory/language/no"
import no_integration from "../modules/integrations/language/no"
import no_frontend from "../modules/frontend/language/no"
import no_notificationtemplate from "../modules/notificationtemplates/language/no"
import no_notification from "../modules/notifications/language/no"
import no_changelog from "../modules/changelog/language/no"
import no_modules from "../modules/modules/language/no"

/* NN - NYNORSK */
import nn_global from "../languages/nn"
import nn_dashboard from "../modules/dashboard/language/nn"
import nn_settings from "../modules/settings/language/nn"
import nn_auth from "../modules/auth/language/nn"
import nn_users from "../modules/users/language/nn"
import nn_persons from "../modules/persons/language/nn"
import nn_roles from "../modules/roles/language/nn"
import nn_permissions from "../modules/permissions/language/nn"
import nn_organisations from "../modules/organisations/language/nn"
import nn_coursetemplates from "../modules/coursetemplates/language/nn"
import nn_tennants from "../modules/tennants/language/nn"
import nn_logs from "../modules/logs/language/nn"
import nn_queues from "../modules/queues/language/nn"
import nn_classes from "../modules/classes/language/nn"
import nn_coursetypegroups from "../modules/coursetypegroups/language/nn"
import nn_coursetypes from "../modules/coursetypes/language/nn"
import nn_moduletemplates from "../modules/moduletemplates/language/nn"
import nn_moduleoptions from "../modules/moduleoptions/language/nn"
import nn_moduleoptioncoursetypes from "../modules/moduleoptioncoursetypes/language/nn"
import nn_customergroups from "../modules/customergroups/language/nn"
import nn_reports from "../modules/reports/language/nn"
import nn_educationprograms from "../modules/educationprograms/language/nn"
import nn_tenantroles from "../modules/tenantroles/language/nn"
import nn_checklist from "../modules/checklist/language/nn"
import nn_checklistapi from "../mixins/components/checklist/languages/nn"
import nn_checklisttemplate from "../modules/checklisttemplate/language/nn"
import nn_checklisttemplatecategory from "../modules/checklisttemplatecategory/language/nn"
import nn_integration from "../modules/integrations/language/nn"
import nn_frontend from "../modules/frontend/language/nn"
import nn_notificationtemplate from "../modules/notificationtemplates/language/nn"
import nn_notification from "../modules/notifications/language/nn"
import nn_changelog from "../modules/changelog/language/nn"
import nn_modules from "../modules/modules/language/nn"

const locales = {
  en: {
    global: en_global,
    settings: en_settings,
    dashboard: en_dashboard,
    auth: en_auth,
    users: en_users,
    persons: en_persons,
    roles: en_roles,
    permissions: en_permissions,
    organisations: en_organisations,
    coursetemplates: en_coursetemplates,
    tennants: en_tennants,
    logs: en_logs,
    queues: en_queues,
    classes: en_classes,
    coursetypegroups: en_coursetypegroups,
    coursetypes: en_coursetypes,
    moduletemplates: en_moduletemplates,
    moduleoptions: en_moduleoptions,
    moduleoptioncoursetypes: en_moduleoptioncoursetypes,
    customergroups: en_customergroups,
    reports: en_reports,
    educationprograms: en_educationprograms,
    tenantroles: en_tenantroles,
    checklist: en_checklist,
    checklistapi: en_checklistapi,
    checklisttemplate: en_checklisttemplate,
    checklisttemplatecategory: en_checklisttemplatecategory,
    integrations: en_integration,
    fe: en_frontend,
    notificationtemplates: en_notificationtemplate,
    notifications: en_notification,
    changelog: en_changelog,
    modules: en_modules,
  },

  no: {
    global: no_global,
    settings: no_settings,
    dashboard: no_dashboard,
    auth: no_auth,
    users: no_users,
    persons: no_persons,
    roles: no_roles,
    permissions: no_permissions,
    organisations: no_organisations,
    coursetemplates: no_coursetemplates,
    tennants: no_tennants,
    logs: no_logs,
    queues: no_queues,
    classes: no_classes,
    coursetypegroups: no_coursetypegroups,
    coursetypes: no_coursetypes,
    moduletemplates: no_moduletemplates,
    moduleoptions: no_moduleoptions,
    moduleoptioncoursetypes: no_moduleoptioncoursetypes,
    customergroups: no_customergroups,
    reports: no_reports,
    educationprograms: no_educationprograms,
    tenantroles: no_tenantroles,
    checklist: no_checklist,
    checklistapi: no_checklistapi,
    checklisttemplate: no_checklisttemplate,
    checklisttemplatecategory: no_checklisttemplatecategory,
    integrations: no_integration,
    fe: no_frontend,
    notificationtemplates: no_notificationtemplate,
    notifications: no_notification,
    changelog: no_changelog,
    modules: no_modules,
  },

  nn: {
    global: nn_global,
    settings: nn_settings,
    dashboard: nn_dashboard,
    auth: nn_auth,
    users: nn_users,
    persons: nn_persons,
    roles: nn_roles,
    permissions: nn_permissions,
    organisations: nn_organisations,
    coursetemplates: nn_coursetemplates,
    tennants: nn_tennants,
    logs: nn_logs,
    queues: nn_queues,
    classes: nn_classes,
    coursetypegroups: nn_coursetypegroups,
    coursetypes: nn_coursetypes,
    moduletemplates: nn_moduletemplates,
    moduleoptions: nn_moduleoptions,
    moduleoptioncoursetypes: nn_moduleoptioncoursetypes,
    customergroups: nn_customergroups,
    reports: nn_reports,
    educationprograms: nn_educationprograms,
    tenantroles: nn_tenantroles,
    checklist: nn_checklist,
    checklistapi: nn_checklistapi,
    checklisttemplate: nn_checklisttemplate,
    checklisttemplatecategory: nn_checklisttemplatecategory,
    integrations: nn_integration,
    fe: nn_frontend,
    notificationtemplates: nn_notificationtemplate,
    notifications: nn_notification,
    changelog: nn_changelog,
    modules: nn_modules,
  }
}

let user = localStorage.getItem("__crrntUser")
let locale = "en"

if (user) {
  user = JSON.parse(user)

  if (user) {
    // HACK: IF THE SETTINGS IN THE LOCALSTORAGE IS NOT ARRAY, IT MEANS THAT THEIR SETTINGS IS NOT YET UPDATED, WILL DO FORCE LOGOUT
    if (!Array.isArray(user.settings)) {
      localStorage.removeItem("__crrntUser")
      router.push("/auth/no/login")
    } else {
      locale = user.settings.find((i) => i.key == "locale").value
    }
  }
}

export default new VueI18n({
  locale: "",
  fallbackLocale: locale,
  messages: locales,
  silentTranslationWarn: true
})
